import { createSelector } from '@ngrx/store';

export const getUsersState = createSelector(
    (state: any) => state.users,
    (state: any) => state.get('list')
);

export const getCreateUserState = createSelector(
    (state: any) => state.users,
    (state: any) => state.get('createUser')
);

export const getUpdateUserState = createSelector(
    (state: any) => state.users,
    (state: any) => state.get('updateUser')
);

export const getUserDetailsState = createSelector(
    (state: any) => state.users,
    (state: any) => state.getIn(['userDetails', 'data'])
);

export const getRoles = createSelector(
    (state: any) => state.users,
    (state: any) => state.getIn(['roles', 'data'])
);
